var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.options
    ? _c(
        "q-btn-dropdown",
        {
          staticClass: "inspection-status text-white",
          class: "bg-" + _vm.selectedStatus.color,
          attrs: {
            label: _vm.selectedStatus.label,
            "no-caps": "",
            "no-item-animation": "",
            "content-class": "inspection-status-dropdown",
            disable: _vm.isTerminalState(_vm.selectedStatus.value)
          }
        },
        [
          _c(
            "q-list",
            _vm._l(_vm.options, function(option, key) {
              return _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" }
                  ],
                  key: key,
                  staticClass: "text-white cursor-pointer mx-3 my-2 rounded",
                  class: "bg-" + option.color,
                  attrs: { disabled: key === "PAYMENT_FAILED", clickable: "" },
                  nativeOn: {
                    click: function($event) {
                      _vm.setStatus(option.value)
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(option.label) + "\n    ")]
              )
            })
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }